import { IOwnershipMetadata } from "../../interfaces/ownership.interface";

const ActionTypes = {
    GET_OWNERSHIP_METADATA: '[Ownership] Get Ownership Meta Data',
    GET_OWNERSHIP_METADATA_SUCCESS: '[Ownership] Get Ownership Meta Data Success',
    GET_OWNERSHIP_METADATA_FAIL: '[Ownership] Get Ownership Meta Data Fail',

    GET_OWNERSHIP_NODES_BYHASH: '[Ownership] Get Ownership Nodes',
    GET_OWNERSHIP_NODES_BYHASH_SUCCESS: '[Ownership] Get Ownership Nodes Success',
    GET_OWNERSHIP_NODES_BYHASH_FAIL: '[Ownership] Get Ownership Nodes Fail',

    GET_OWNERSHIP_EDGES_BYHASH: '[Ownership] Get Ownership Edges',
    GET_OWNERSHIP_EDGES_BYHASH_SUCCESS: '[Ownership] Get Ownership Edges Success',
    GET_OWNERSHIP_EDGES_BYHASH_FAIL: '[Ownership] Get Ownership Edges Fail',
}

export class GetOwnershipMetadata {
    static type = ActionTypes.GET_OWNERSHIP_METADATA;
    constructor(public payload: {firmId: string, year?: number}) {} // payload is the firmId and optional year
}

export class GetOwnershipMetadataSuccess {
    static type = ActionTypes.GET_OWNERSHIP_METADATA_SUCCESS;
    constructor(public payload: IOwnershipMetadata, public metadata: {firmId: string, year?: number} ) {} // payload is the ownership metadata
}

export class GetOwnershipMetadataFail {
    static type = ActionTypes.GET_OWNERSHIP_METADATA_FAIL;
    constructor(public payload: any) {} // payload is the error response
}

export class GetOwnershipNodesByHash {
    static type = ActionTypes.GET_OWNERSHIP_NODES_BYHASH;
    constructor(public payload: {hash: string, year: number}) {} // payload is the hash
}

export class GetOwnershipNodesByHashSuccess {
    static type = ActionTypes.GET_OWNERSHIP_NODES_BYHASH_SUCCESS;
    constructor(public payload: any, public metadata: {hash: string, year: number}) {} // payload is the ownership nodes
}

export class GetOwnershipNodesByHashFail {
    static type = ActionTypes.GET_OWNERSHIP_NODES_BYHASH_FAIL;
    constructor(public payload: any, public metadata?: {hash: string, year: number}) {} // payload is the error response
}

export class GetOwnershipEdgesByHash {
    static type = ActionTypes.GET_OWNERSHIP_EDGES_BYHASH;
    constructor(public payload: {hash: string, year: number}) {} // payload is the hash
}

export class GetOwnershipEdgesByHashSuccess {
    static type = ActionTypes.GET_OWNERSHIP_EDGES_BYHASH_SUCCESS;
    constructor(public payload: any, public metadata: {hash: string, year: number}) {} // payload is the ownership edges
}

export class GetOwnershipEdgesByHashFail {
    static type = ActionTypes.GET_OWNERSHIP_EDGES_BYHASH_FAIL;
    constructor(public payload: any, public metadata?: {hash: string, year: number}) {} // payload is the error response
}